"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconHydrogenPowerTruck = function IconHydrogenPowerTruck(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m23.04 10 1.414 1.414-3.063 3.063a3.5 3.5 0 0 1-.782 4.822l3.977 4.021v.001a3.91 3.91 0 0 1-.018 5.515 3.91 3.91 0 0 1-5.375.153l-.16-.152L15 24.804V43h-2V16a3 3 0 0 0-2.824-2.995L10 13H6v-2h4a5 5 0 0 1 4.995 4.783L15 16v5.976l5.447 5.447-.643.643.644-.642a1.91 1.91 0 0 0 2.706-.002 1.91 1.91 0 0 0 .113-2.58l-.113-.124v-.001l-5.264-5.322a3 3 0 0 1-.136-4.1l.136-.145zm-3.736 6.565 1.364-1.365a2.5 2.5 0 0 1-.772 3.378l-.592-.598-.087-.1a1 1 0 0 1 .087-1.315M7.745 27.655V22H6.718v2.19H4.036V22H3v5.654h1.036v-2.481h2.682v2.482zm1.873.509-1.054.909v.754H11V29H9.8l.554-.464c.363-.236.59-.632.61-1.063 0-.61-.446-.991-1.21-.991a1.1 1.1 0 0 0-1.263 1.19H9.4a.31.31 0 0 1 .327-.345.255.255 0 0 1 .282.264c0 .22-.187.388-.371.555zm26.869 9.85a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M28 17v20H18v2h12V19h5v6.5a2.5 2.5 0 0 0 2.5 2.5h4.42l.08.19V36a1 1 0 0 1-1 1h-.1a5 5 0 1 0 0 2h.1a3 3 0 0 0 3-3v-8.19l-3.57-8.92A3 3 0 0 0 37.65 17H28m8 24a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0-15.5a1.5 1.5 0 0 0 1.5 1.5h4.07l-3-7.37a1 1 0 0 0-.92-.63H36z",
    clipRule: "evenodd"
  })));
};

export { IconHydrogenPowerTruck, IconHydrogenPowerTruck as default };
